"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const amplitude = __importStar(require("@amplitude/analytics-browser"));
const detect_browser_1 = require("detect-browser");
const uniqid_1 = __importDefault(require("uniqid"));
const web_vitals_1 = require("web-vitals");
const campaign_attributes_1 = require("./campaign-attributes");
const get_is_bot_1 = __importDefault(require("./get-is-bot"));
const get_is_in_iframe_1 = require("./get-is-in-iframe");
const get_production_api_key_1 = require("./get-production-api-key");
const get_proxy_url_1 = __importDefault(require("./get-proxy-url"));
const storage_1 = __importDefault(require("./storage"));
const literal = (str) => str;
const CLICK = literal('Click');
const CUMULATIVE_LAYOUT_SHIFT = literal('Cumulative Layout Shift');
const ERROR = literal('Error');
const INTERACTION_TO_NEXT_PAINT = literal('Interaction to Next Paint');
const LARGEST_CONTENTFUL_PAINT = literal('Largest Contentful Paint');
const MEDIA_ENDED = literal('Media Ended');
const MEDIA_PAUSE = literal('Media Pause');
const MEDIA_LOAD_START = literal('Media Load Start');
const MEDIA_PLAY = literal('Media Play');
const MEDIA_SEEKED = literal('Media Seeked');
const PAGE_HIDE = literal('Page Hide');
const PAGE_SHOW = literal('Page Show');
const PAGE_VIEW = literal('Page View');
const PAGE_VIEW_REPLACE = literal('Page View Replace');
function track(_event, _options) {
    // This will be implemented in the Amplitude class
}
const debounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), timeout);
    };
};
const memoizeToExecuteOnce = (func) => {
    let hasRun = false;
    let result;
    return (...args) => {
        if (hasRun) {
            return result;
        }
        hasRun = true;
        result = func(...args);
        return result;
    };
};
class Amplitude {
    constructor({ apiKey, defaultClickTracking = false, internal, locale, anonymize = true }) {
        this.anonymize = false;
        this.defaultClickTracking = false;
        this.historyReplaceStateCalledInternally = false;
        this.initialized = false;
        this.internal = false;
        this.pageViewId = (0, uniqid_1.default)();
        this.pageViewPercent = 0;
        this.pageVisible = true;
        this.queue = [];
        this.trackedCLS = false;
        this.trackedINP = false;
        this.trackedLCP = false;
        this.tracking = null;
        this.getOptionsMedia = (element) => {
            return {
                'Media Autoplay': element.autoplay,
                'Media Duration': Math.round(element.duration),
                'Media Element': (element === null || element === void 0 ? void 0 : element.getAttribute('data-track')) || undefined,
                'Media Source': element.src || element.currentSrc,
                'Media Time': Math.round(element.currentTime)
            };
        };
        this.getOptionsPage = () => {
            var _a;
            const { hash, hostname, href, origin, pathname } = window.location;
            return {
                'Page Domain': hostname,
                'Page Hash': hash,
                'Page Locale': this.locale,
                'Page Location': origin + pathname,
                'Page Path': pathname,
                'Page Title': document.title,
                'Page URL': href,
                'Page View ID': this.pageViewId,
                'Screen Height': window.screen.height,
                'Screen Orientation': (_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type,
                'Screen Size': `${window.screen.width}x${window.screen.height}`,
                'Screen Width': window.screen.width,
                'Window Height': window.innerHeight,
                'Window Size': `${window.innerWidth}x${window.innerHeight}`,
                'Window Width': window.innerWidth
            };
        };
        this.getOptionsCampaign = memoizeToExecuteOnce(() => {
            const { pathname, hash, search } = window.location;
            const searchParams = new URLSearchParams(search);
            const { attributes, search: searchAfter } = (0, campaign_attributes_1.getCampaignAttributes)(searchParams);
            let referrerDomain;
            let referrerLocation;
            let referrerPath;
            let referrerURL;
            try {
                if (!(0, get_is_in_iframe_1.getIsInIFrame)()) {
                    const { hostname, href, origin, pathname: pathReferrer } = new URL(document.referrer);
                    referrerDomain = hostname;
                    referrerLocation = origin + pathReferrer;
                    referrerPath = pathReferrer;
                    referrerURL = href;
                }
            }
            catch {
                // Do nothing
            }
            this.historyReplaceStateCalledInternally = true;
            window.history.replaceState({}, '', `${pathname}${searchAfter ? `?${searchAfter}` : ''}${hash ? hash : ''}`);
            this.historyReplaceStateCalledInternally = false;
            return {
                ...attributes,
                'Referrer Domain': referrerDomain,
                'Referrer Location': referrerLocation,
                'Referrer Path': referrerPath,
                'Referrer URL': referrerURL
            };
        });
        this.getOptionsUser = memoizeToExecuteOnce(() => {
            const browser = (0, detect_browser_1.detect)(window.navigator.userAgent);
            const campaign = this.getOptionsCampaign();
            return {
                ...campaign,
                'Browser Name': (browser === null || browser === void 0 ? void 0 : browser.name) ? browser.name : undefined,
                'Browser Version': (browser === null || browser === void 0 ? void 0 : browser.version) ? browser.version : undefined,
                Internal: this.internal ? true : undefined,
                'Moderna Library': process.env.LIBRARY
            };
        });
        this.getPageViewedPercent = () => {
            const percentPrevious = this.pageViewPercent || 0;
            const scrollPosition = Math.max(window.scrollY, 0);
            const percentCurrent = Math.round(((scrollPosition + window.innerHeight) / document.body.scrollHeight) * 100);
            const percentCurrentBounded = Math.min(percentCurrent, 100);
            return percentCurrentBounded > percentPrevious ? percentCurrentBounded : percentPrevious;
        };
        this.handleVisibilityChange = () => {
            if (document.hidden && this.pageVisible) {
                this.pageVisible = false;
                this.track('Page Hide', {
                    'Page View Percent': this.getPageViewedPercent()
                });
            }
            else if (!this.pageVisible) {
                this.pageVisible = true;
                this.track('Page Show', {
                    'Page View Percent': this.getPageViewedPercent()
                });
            }
        };
        this.handleClick = (event) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (this.defaultClickTracking && event.target instanceof HTMLElement) {
                const target = event.target;
                const elementClickable = target === null || target === void 0 ? void 0 : target.closest('a, button');
                const elementAttributed = target === null || target === void 0 ? void 0 : target.closest('[data-track]');
                const elementShadow = target.shadowRoot
                    ? (_a = target === null || target === void 0 ? void 0 : target.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('a, button')
                    : null;
                this.track('Click', {
                    'Click Element': (elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.getAttribute('data-track')) || undefined,
                    'Click Position': `${event.pageX}x${event.pageY}`,
                    'Click Text': ((_b = elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.textContent) === null || _b === void 0 ? void 0 : _b.trim()) ||
                        ((_c = elementAttributed === null || elementAttributed === void 0 ? void 0 : elementAttributed.getAttribute('aria-label')) === null || _c === void 0 ? void 0 : _c.trim()) ||
                        ((_d = elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.textContent) === null || _d === void 0 ? void 0 : _d.trim()) ||
                        ((_e = elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.getAttribute('aria-label')) === null || _e === void 0 ? void 0 : _e.trim()) ||
                        ((_f = elementShadow === null || elementShadow === void 0 ? void 0 : elementShadow.textContent) === null || _f === void 0 ? void 0 : _f.trim()) ||
                        ((_g = elementShadow === null || elementShadow === void 0 ? void 0 : elementShadow.getAttribute('aria-label')) === null || _g === void 0 ? void 0 : _g.trim()) ||
                        undefined,
                    'Click URL': (elementClickable === null || elementClickable === void 0 ? void 0 : elementClickable.getAttribute('href')) || undefined,
                    'Click X': event.pageX,
                    'Click Y': event.pageY
                });
            }
        };
        this.handleError = (event) => {
            const error = event.error;
            const hasSource = (error === null || error === void 0 ? void 0 : error.filename) && (error === null || error === void 0 ? void 0 : error.lineno) && (error === null || error === void 0 ? void 0 : error.colno);
            this.track('Error', {
                'Error Message': error === null || error === void 0 ? void 0 : error.message,
                'Error Source': hasSource ? `${error === null || error === void 0 ? void 0 : error.filename} ${error === null || error === void 0 ? void 0 : error.lineno}:${error === null || error === void 0 ? void 0 : error.colno}` : undefined
            });
            return false;
        };
        this.handleHistoryChange = (method) => {
            // Create a new unique Page View ID for each page view
            this.pageViewId = (0, uniqid_1.default)();
            // Reset the page view percent
            this.pageViewPercent = 0;
            this.pageViewPercent = this.getPageViewedPercent();
            this.track('Page View', {
                'Page Load Method': method,
                'Page Load Type': 'Route Change'
            });
        };
        this.handleHistoryReplaceChange = () => {
            // Create a new unique Page View ID for each page view
            this.pageViewId = (0, uniqid_1.default)();
            // Reset the page view percent
            this.pageViewPercent = 0;
            this.pageViewPercent = this.getPageViewedPercent();
            this.track('Page View Replace', {});
        };
        this.handleHistoryPopState = () => {
            return this.handleHistoryChange('Pop');
        };
        this.handleMediaLoadStart = (event) => {
            this.track('Media Load Start', this.getOptionsMedia(event.target));
        };
        this.handleMediaPlay = (event) => {
            this.track('Media Play', this.getOptionsMedia(event.target));
        };
        this.handleMediaPause = (event) => {
            this.track('Media Pause', this.getOptionsMedia(event.target));
        };
        this.handleMediaSeeked = (event) => {
            this.track('Media Seeked', this.getOptionsMedia(event.target));
        };
        this.handleMediaEnded = (event) => {
            this.track('Media Ended', this.getOptionsMedia(event.target));
        };
        this.handleScroll = debounce(() => {
            this.pageViewPercent = this.getPageViewedPercent();
        }, 100);
        // Device ID is stored in a cookie for domain level tracking when using a proxy.
        this.setDeviceId = () => {
            // When anonymizing tracking data, the cookie expires after 45min. However it will
            // persist with the user until the current page closes since the deviceId is stored
            // during initialization of Amplitude.
            const cookieKey = this.anonymize ? 'MDRNA_AID' : 'MDRNA_DID';
            const cookieExpiry = this.anonymize ? 45 / (60 * 24) : undefined;
            let deviceId = storage_1.default.getItem(cookieKey);
            if (!deviceId) {
                try {
                    // There are some contexts in which randomUUID() may not exist
                    deviceId = crypto.randomUUID();
                }
                catch {
                    deviceId = (0, uniqid_1.default)();
                }
                storage_1.default.setItem(cookieKey, deviceId, cookieExpiry);
            }
            amplitude.setDeviceId(deviceId);
        };
        this.initAmplitude = (optingOut = false) => {
            // We can't change the amplitude configuration after we've
            // initialized it. We also shouldn't track security scanners
            // or bots.
            if (this.initialized || (0, get_is_bot_1.default)() || !this.apiKey) {
                return;
            }
            this.setDeviceId();
            amplitude.add({
                execute: async (event) => {
                    event.event_properties = {
                        ...event.event_properties,
                        ...this.getOptionsCampaign(),
                        ...this.getOptionsPage()
                    };
                    event.user_properties = {
                        ...event.user_properties,
                        ...this.getOptionsUser()
                    };
                    return event;
                }
            });
            amplitude.init(this.apiKey, {
                defaultTracking: {
                    attribution: false,
                    fileDownloads: !optingOut,
                    formInteractions: !optingOut,
                    pageViews: false,
                    sessions: true
                },
                flushIntervalMillis: optingOut ? 100 : 1000,
                identityStorage: 'localStorage',
                optOut: false,
                transport: 'beacon',
                serverUrl: (0, get_proxy_url_1.default)()
            });
            this.initialized = true;
        };
        this.tryTrack = (...args) => {
            if (this.tracking === true) {
                amplitude.track(args[0], args[1]);
            }
            else if (this.tracking === null) {
                this.queue.push([args[0], args[1]]);
                // Don't queue more than 100 events to prevent an (unlikely) memory leak
                // before the user opts in or out
                this.queue.splice(100);
            }
        };
        this.setLocale = (locale) => {
            this.locale = locale;
        };
        this.track = (...args) => {
            this.tryTrack(args[0], args[1]);
        };
        this.trackCustom = (...args) => {
            this.tryTrack(args[0], args[1]);
        };
        this.setUserId = (userId) => {
            amplitude.setUserId(userId);
        };
        this.apiKey = (0, get_production_api_key_1.getProductionApiKey)(apiKey);
        this.defaultClickTracking = defaultClickTracking;
        this.internal = internal;
        this.locale = locale;
        this.anonymize = anonymize;
    }
    addListenOnRouteChanges() {
        // There isn't a way to hook into the history push state, so
        // we need to wrap it up an proxy the original function. For
        // whatever reason, we can't use arrow functions either.
        const self = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.historyPushStateOriginal = window.history.pushState;
        history.pushState = function () {
            setTimeout(() => self.handleHistoryChange('Push'));
            return self.historyPushStateOriginal && self.historyPushStateOriginal.apply(history, arguments);
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.historyReplaceStateOriginal = window.history.replaceState;
        history.replaceState = function () {
            if (!self.historyReplaceStateCalledInternally) {
                setTimeout(() => self.handleHistoryReplaceChange());
            }
            return self.historyReplaceStateOriginal && self.historyReplaceStateOriginal.apply(history, arguments);
        };
    }
    removeListenOnRouteChanges() {
        if (this.historyPushStateOriginal) {
            window.history.pushState = this.historyPushStateOriginal.bind(window.history);
            delete this.historyPushStateOriginal;
        }
        if (this.historyReplaceStateOriginal) {
            window.history.replaceState = this.historyReplaceStateOriginal.bind(window.history);
            delete this.historyReplaceStateOriginal;
        }
    }
    destroy() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('click', this.handleClick);
        window.removeEventListener('ended', this.handleMediaEnded, true);
        window.removeEventListener('error', this.handleError);
        window.removeEventListener('loadstart', this.handleMediaLoadStart, true);
        window.removeEventListener('pause', this.handleMediaPause, true);
        window.removeEventListener('play', this.handleMediaPlay, true);
        window.removeEventListener('popstate', this.handleHistoryPopState);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('seeked', this.handleMediaSeeked, true);
        this.removeListenOnRouteChanges();
    }
    init() {
        const storedOptIn = storage_1.default.getItem('MDRNA_AMPLITUDE');
        this.tracking = storedOptIn === null ? null : Boolean(storedOptIn);
        this.pageViewPercent = this.getPageViewedPercent();
        if (this.tracking) {
            this.initAmplitude();
        }
        this.track('Page View', {
            'Page Load Method': 'Initial',
            'Page Load Type': 'Initial Load'
        });
        (0, web_vitals_1.onCLS)(({ value }) => {
            if (!this.trackedCLS) {
                this.trackedCLS = true;
                this.track('Cumulative Layout Shift', {
                    Percent: value * 100
                });
            }
        });
        (0, web_vitals_1.onINP)(({ value }) => {
            if (!this.trackedINP) {
                this.trackedINP = true;
                this.track('Interaction to Next Paint', {
                    Milliseconds: value
                });
            }
        });
        (0, web_vitals_1.onLCP)(({ value }) => {
            if (!this.trackedLCP) {
                this.trackedLCP = true;
                this.track('Largest Contentful Paint', {
                    Milliseconds: value
                });
            }
        });
        this.addListenOnRouteChanges();
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('click', this.handleClick);
        window.addEventListener('ended', this.handleMediaEnded, true);
        window.addEventListener('error', this.handleError);
        window.addEventListener('loadstart', this.handleMediaLoadStart, true);
        window.addEventListener('pause', this.handleMediaPause, true);
        window.addEventListener('play', this.handleMediaPlay, true);
        window.addEventListener('popstate', this.handleHistoryPopState);
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('seeked', this.handleMediaSeeked, true);
    }
    optIn(optInValue) {
        if (optInValue && !this.tracking) {
            this.tracking = true;
            storage_1.default.setItem('MDRNA_AMPLITUDE', '1');
            amplitude.setOptOut(false);
            this.initAmplitude();
            amplitude.track('Opt In');
            this.queue.forEach((event) => amplitude.track(event[0], event[1]));
            this.queue = [];
        }
        else if (!optInValue && this.tracking !== false) {
            this.initAmplitude(true);
            amplitude.track('Opt Out');
            amplitude.flush();
            this.tracking = false;
            storage_1.default.setItem('MDRNA_AMPLITUDE', '');
            // We need to delay configuring opt out until the opt out event
            // has sent, which can be up to a second or more from this moment
            // if the user originally opted in.
            setTimeout(() => amplitude.setOptOut(true), 2000);
            this.queue = [];
        }
    }
}
exports.default = Amplitude;
